module.exports = __webpack_public_path__ + "img/worker.1c353c31.svg";